import React from "react";
import { Route, withRouter } from "react-router-dom";

class EditButton extends React.Component {
  btn = props => {
    var classes =
      "link-button" + (props.margin_auto === "true" ? " margin-auto" : "");
    var to =
      props.to + (props.id !== undefined || props.id !== "" ? props.id : "");

    return (
      <Route
        render={({ history }) => (
          <button
            className={classes}
            onClick={() => {
              history.push(to);
            }}
          >
            <i aria-hidden="true" className="material-icons icon-link-button">
              create
            </i>
            <div className="font-size-smaller text-link-button">
              {props.text("common.edit")}
            </div>
          </button>
        )}
      />
    );
  };

  render() {
    return this.btn(this.props);
  }
}

export default withRouter(EditButton);






// WEBPACK FOOTER //
// ./src/components/buttons/EditButton.js